const sliderLoanResult = document.querySelector('#slider-loan-result');
const sliderLoan = document.querySelector('#slider-loan');
const sliderWeekResult = document.querySelector('#slider-week-result');
const sliderWeek = document.querySelector('#slider-week');
const loanResult = document.querySelector('#loan-result');

sliderLoan.addEventListener('change', function (e) {
    sliderLoanResult.textContent = "$" + (this.value == 2000 ? 2001 : this.value)
    calculateLoanResult()
});


sliderWeek.addEventListener('change', function (e) {
    sliderWeekResult.textContent =  this.value + " weeks"
    calculateLoanResult()
});

const calculateLoanResult = () => {
    let principle = (parseFloat(sliderLoan.value) == 2000 ? 2001 : parseFloat(sliderLoan.value)) + 400;
    let weeks = parseInt(sliderWeek.value);
    let rate = 0.48/52.18;
    let totalFee = calculatePMT(principle, weeks, rate);
    loanResult.textContent = "$" + toFixed(totalFee, 2);
}

const calculatePMT = (pv, n, r) => {
    // PMT = PV * r / (1 - (1 + r)^(-n))
    const pmt = pv * r / (1 - Math.pow(1 + r, -n));
    return pmt;
};

const toFixed = (num, fixed) => {
    fixed = fixed || 0;
    fixed = Math.pow(10, fixed);
    return Math.floor(num * fixed) / fixed;
}

calculateLoanResult()

